import React, { PropsWithChildren, CSSProperties } from 'react';

import { makeClassNames } from '../../../utils/styles';
import './football-team-content.scss';

const classNames = () =>
  makeClassNames({
    content: 'football-team-content',
    item: [`players-card`, `player-card__player--full-link`],
  });

const cn = classNames();

export interface IFootballTeamContent {
  playerTeamColor: string;
}

const FootballTeamContent = (props: PropsWithChildren<IFootballTeamContent>) => {
  const { playerTeamColor, children } = props;
  const styleBackground: CSSProperties = { backgroundColor: playerTeamColor };

  return (
    <div className={cn.item} style={styleBackground}>
      <div className={cn.content}>{children}</div>
    </div>
  );
};

export default FootballTeamContent;
